import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSub = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_574_3747)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 12,
					cy: 12,
					r: 12,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.47 16.5C9.70585 16.2401 9.02054 15.7898 8.47874 15.1915C7.93694 14.5933 7.55653 13.8668 7.37339 13.0808C7.19026 12.2947 7.21045 11.4749 7.43206 10.6988C7.65367 9.92269 8.06939 9.21586 8.63999 8.64501L6.87499 6.88C5.95459 7.80126 5.29932 8.95342 4.97803 10.2154C4.65674 11.4774 4.68129 12.8026 5.0491 14.0518C5.41691 15.3011 6.1144 16.4282 7.06828 17.3147C8.02216 18.2012 9.19722 18.8145 10.47 19.09V22L14 19V17L10.47 14V16.5Z",
					fill: "#D22A5D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.125 6.875C16.1425 5.88635 14.8933 5.20528 13.53 4.915V2L10 5V7L13.53 10V7.5C14.2941 7.7599 14.9794 8.21022 15.5212 8.80848C16.063 9.40673 16.4435 10.1332 16.6266 10.9192C16.8097 11.7053 16.7895 12.5251 16.5679 13.3012C16.3463 14.0773 15.9306 14.7841 15.36 15.355L17.125 17.12C17.7984 16.4472 18.3325 15.6482 18.697 14.7689C19.0614 13.8895 19.249 12.9469 19.249 11.995C19.249 11.0431 19.0614 10.1005 18.697 9.22114C18.3325 8.34177 17.7984 7.54283 17.125 6.87V6.875Z",
					fill: "#03B155"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 23,
			height: 23,
			rx: 11.5,
			stroke: "#CAC5DD"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_574_3747",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				rx: 12,
				fill: "white"
			})
		}) })
	]
});
export default SvgSub;
